import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import { fetchUsers, setOneUser, UserAction } from './actions'
import { UserState } from './types'

export const userReducer = combineReducers<UserState, UserAction>({
  isFetching: (isFetching = false, action) => {
    switch (action.type) {
      case getType(fetchUsers.request):
        return true
      case getType(fetchUsers.success):
      case getType(fetchUsers.failure):
        return false
      default:
        return isFetching
    }
  },
  items: (users = {}, action) => {
    switch (action.type) {
      case getType(fetchUsers.success): {
        return action.payload
      }
      case getType(setOneUser): {
        const user = action.payload
        return {
          ...users,
          [user.id]: user,
        }
      }
      default:
        return users
    }
  },
})
